/**
 * products
 */

import $ from "jquery";
import anime from "animejs";
import Product from "../product/product";
import Component, { nextTick, publish, debounce } from "../../js/lib/component";
import Query from "../../js/lib/query";
import Cookie from "../../js/lib/cookie";

const classList = {
  root: ".js-products",
  container: ".js-products-container",
  filter: ".js-products-filter",
  item: ".js-products-item"
};
export default class Products extends Component {
  init() {
    this.sort = this.childs("Sort")._one();
    this.view = this.childs("View")._one();
    this.page = this.parents("Page")._one();
    this.filters = this.page.childs("Filter");
    this.loading = false;

    this.debouncedUpdate = debounce(nextState => {
      this.update(nextState);
    }, 200);

    nextTick().then(() => {
      if (this.sort) {
        this.setState({ sort: this.sort.state.value });
      }

      if (this.view) {
        this.setState({ view: this.view.state.type });
        Cookie.set("product_view", this.view.state.type);
      }

      if (this.filters.length) {
        const filter = this.filters.find(filter => filter.state.active);

        if (filter) {
          this.setState({ filter: filter.state.params });
        }
      }

      this.setView();
      this.$.root.addClass("is-inited");
    });
  }
  events() {
    this.$.root.on("view.change", (e, { type, toggle, unlock }) => {
      e.stopPropagation();
      this.setState({ view: type });
      this.setView(toggle, unlock);
      // this.setQuery();
      Cookie.set("product_view", type);
    });

    this.$.root.on("sort.change", (e, { value }) => {
      e.stopPropagation();
      const nextState = { sort: value };
      this.setState(nextState);
      this.debouncedUpdate(nextState);
      this.setQuery(nextState);
    });

    this.$.document.on("filter.change", (e, { params }) => {
      const nextState = { filter: params };
      this.setState(nextState);
      this.debouncedUpdate(nextState);
      this.setQuery(nextState);
    });

    this.$.filter.on("click", () => {
      publish("sidebar:show");
    });
  }
  setView(toggle, unlock) {
    if (toggle) {
      this.hide().then(() => {
        this.$.root.attr("data-view", this.state.view);
        toggle();
        this.show().then(() => {
          unlock();
        });
      });
    } else {
      this.$.root.attr("data-view", this.state.view);
    }
  }
  getParams(nextState = {}) {
    const filter =
      Object.prototype.hasOwnProperty.call(nextState, "filter") &&
      nextState.filter !== undefined
        ? nextState.filter
        : this.state.filter;
    const sort =
      Object.prototype.hasOwnProperty.call(nextState, "sort") &&
      nextState.sort !== undefined
        ? nextState.sort
        : this.state.sort;
    const { view } = this.state;
    const search = Query.parse({ rebuild: true });
    const params = Object.assign({}, /*search,*/ filter /*, view*/);

    if (sort && sort !== "is_hit") {
      params.sort = sort;
    }

    // clear empty keys
    for (const key in params) {
      if (params.hasOwnProperty(key) && !params[key]) {
        delete params[key];
      }
    }

    return params;
  }
  setQuery(nextState = {}) {
    const { origin, pathname } = location;
    const params = this.getParams(nextState);
    const query = Query.build(params);
    const hash = window.location.hash;
    const path = `${origin}${pathname}${query}${hash ? `${hash}` : ""}`;

    history.replaceState("", "", path);
  }
  update(nextState = {}) {
    const params = this.getParams(nextState);
    $.ajax(location.pathname, {
      data: params,
      beforeSend: () => {
        this.hidePromise = this.hide().then(() => {
          this.timer = setTimeout(() => {
            this.$.root.addClass("is-loading");
            this.loading = true;
          }, 800);
        });
      }
    })
      .done(({ products }) => {
        this.hidePromise.then(() => {
          clearTimeout(this.timer);

          this.$.container.html(products);
          this.$.item = this.$.root.find(classList.item);

          this.$.item.css({ opacity: 0 });

          const mount = () => {
            const products = Product.mount();
            const promises = products.length
              ? products.map((i, product) => {
                  return new Promise(resolve => {
                    product.onInit(() => resolve());
                  });
                })
              : [];

            Promise.all(promises).then(() => {
              this.show();
            });
          };

          if (this.loading) {
            setTimeout(() => {
              this.$.root.removeClass("is-loading");
              mount();
            }, 800);
          } else {
            mount();
          }
        });
      })
      .fail(error => {
        clearTimeout(this.timer);

        setTimeout(() => {
          this.$.root.removeClass("is-loading");
        }, 800);

        this.show();

        console.error(error);
      });
  }
  hide() {
    return new Promise(resolve => {
      anime({
        targets: this.$.item.get(),
        opacity: 0,
        easing: "easeOutCubic",
        delay: 50,
        duration: 600,
        complete: () => {
          resolve();
        }
      });
    });
  }
  show() {
    return new Promise(resolve => {
      const targets = this.$.item.get();

      anime.set(targets, {
        opacity: 0,
        translateY: 30
      });

      setTimeout(() => {
        anime({
          targets,
          opacity: 1,
          translateY: 0,
          easing: "easeOutCubic",
          duration: 500,
          delay: anime.stagger(60),
          complete: () => {
            resolve();
          }
        });
      }, 0);
    });
  }
}

Component.mount(Products, {
  name: "Products",
  classList,
  state: {}
});
